"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationPresetDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
class NotificationPresetDto {}
exports.NotificationPresetDto = NotificationPresetDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], NotificationPresetDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], NotificationPresetDto.prototype, "name", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], NotificationPresetDto.prototype, "enabled", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.NotificationPresetTrigger
}), __metadata("design:type", String)], NotificationPresetDto.prototype, "trigger", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.NotificationPresetVariant
}), __metadata("design:type", String)], NotificationPresetDto.prototype, "variant", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Minutes after signup before this preset is eligible.'
}), __metadata("design:type", Number)], NotificationPresetDto.prototype, "delayMinutes", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], NotificationPresetDto.prototype, "sortOrder", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Higher values win when multiple presets share a trigger.'
}), __metadata("design:type", Number)], NotificationPresetDto.prototype, "priority", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.NotificationPresetVenuePresence
}), __metadata("design:type", String)], NotificationPresetDto.prototype, "venuePresence", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], NotificationPresetDto.prototype, "messageTemplate", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.NotificationType
}), __metadata("design:type", String)], NotificationPresetDto.prototype, "notificationType", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", Object)], NotificationPresetDto.prototype, "minCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", Object)], NotificationPresetDto.prototype, "deepLinkTarget", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'When true, mobile may bypass the daily notification frequency cap for this preset.'
}), __metadata("design:type", Boolean)], NotificationPresetDto.prototype, "exemptFromDailyFrequencyCap", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'When true, each send is written to server logs for debugging.'
}), __metadata("design:type", Boolean)], NotificationPresetDto.prototype, "shouldLogSends", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], NotificationPresetDto.prototype, "createdAt", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], NotificationPresetDto.prototype, "updatedAt", void 0);
//# sourceMappingURL=NotificationPreset.dto.js.map